import React, {Suspense, useContext, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
// import PropertySections from "../../components/templates/property/sections/PropertySections";
import { Fancybox } from '@fancyapps/ui/dist/fancybox.esm';
import { config } from '@fortawesome/fontawesome-svg-core';
import Redis, {RedisOptions} from 'ioredis'
import MobileDetect from 'mobile-detect';
import dynamic from 'next/dynamic';

import Addons from '../../components/Addons';
import * as appContext from '../../components/AppContext';
import PropertyComponent from '../../components/entities/property';
import BuilderHead from '../../components/head/BuilderHead';
import { InlineStyles } from '../../components/templates/index/partials/InlineStyles';
import Checkers from '../../helpers/class/Checkers';
import * as DataFetchHelper from '../../helpers/DataFetchHelper';
import * as MethodHelper from '../../helpers/MethodHelper';
import {
  fetchPropertyAvailability, setBookingType, setBookUrl, setHasWebhotelier, setHidePrices, setIsBookingsActive,
  setIsDesktop,
  setIsMobile, setIsOpenCalendar,
  setIsTablet,
  setPageId, setRoomCode, updateHideUnavailableProperties,
  updatepropertyAvailability, updatepropertyAvailabilityForCheckout, updatePropertyInitialAvailability
} from '../../redux/actions';
import { wrapper } from '../../redux/store';

import '@fortawesome/fontawesome-svg-core/styles.css';
import {useIsSSR} from "@react-aria/ssr";
import MainLayout from "../../layouts/MainLayout";
import {fetchHtmlSectionsData} from "../../helpers/DataFetchHelper";

config.autoAddCss = false;

const PropertySections = dynamic( () => import( '../../components/templates/property/sections/PropertySections' ), { suspense: true });
const Scripts = dynamic( () => import( '../../components/Scripts' ), { ssr: false });
const PropertyScripts = dynamic( () => import( '../../components/PropertyScripts' ), { ssr: false });

export const Property = ( props ) => {

  const pageContext = useContext( appContext.page );
  pageContext.pageId = props.app_data.page_id;

  pageContext.appSettings = props.app;

  const [ urlHref, setUrlHref ] = useState( null );

  React.useEffect( () => {
    Fancybox.bind( "[data-fancybox]", {
      Image: {
        zoom: false
      },
      on: {
        load: () => {
          if ( document !== undefined ) {
            const modal = document.querySelector( '.modal' );
            if ( modal )
              modal.classList.remove( 'show' )
          }
        },
        destroy: () => {
          if ( document !== undefined ) {
            const modal = document.querySelector( '.modal' );
            if ( modal )
              modal.classList.add( 'show' )
          }
        }
      }
    });
    if ( window !== undefined ) {
      setUrlHref( window.location.href + '/' );
    }
  }, [urlHref]);

  const domain = props.domain;
  const app = props.app;
  const builder = props.builder;
  const head = props.head;
  const footer = props.footer;

  const app_data = props.app_data;
  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const all_images = props.all_images;
  const features = props.features;
  const rgbDesignColor = props.rgbDesignColor;
  const rgbSearchbarColor = props.rgbSearchbarColor;

  const isDesktop = useSelector( state => state['appSettings']['isDesktop']); // props.isDesktop;
  const captchaSiteKey = '6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY';

  const meta_desc = content.details.meta_desc == null ? content.details.description : content.details.meta_desc;

  const getMetaImage = () => {
    if ( Checkers.isValidArray(props.content.album) && Checkers.isValidString(props.content.album[0].image) ) {
      return props.content.album[0].image
    }

    return Checkers.isValidArray( head.og_image ) ? head.og_image[0].image : null;
  }

  return (
      <MainLayout {...props}>
        <InlineStyles key={0} app={app} rgbDesignColor={rgbDesignColor} rgbSearchbarColor={rgbSearchbarColor}/>
        <BuilderHead
          key={1}
          title={content.details.property_title + ' - ' + content.details.motto + ' | ' + head.data.title}
          keywords={content.details.metaKeywords}
          titleOfficial={head.data.titleOfficial}
          domain={urlHref}
          icon_60={head.data.icon_60}
          icon_76={head.data.icon_76}
          icon_120={head.data.icon_120}
          icon_152={head.data.icon_152}
          icon_256={head.data.icon_256}
          icon={head.data.icon}
          title_fb_meta={content.details.property_title + ' - ' + content.details.motto}
          desc_fb_meta={meta_desc}
          image_fb_meta={getMetaImage()}
          site_name_fb_meta={head.data.title}
          lat_fb_meta={content.location.latitude}
          lon_fb_meta={content.location.longitude}
          twitter_img_alt={content.details.property_title + ' - ' + content.details.motto + '. ' + content.details.metaDesc}
          googleSchemaContext={domain}
          googleSchemaTitle={head.data.title}
          googleSchemaStreetAddress={head.location[0].address}
          googleSchemaCity={head.location[0].city}
          googleSchemaCountry={head.location[0].country}
          googleSchemaZip={head.location[0].zip}
          googleSchemaPhone={head.location[0].phone}
          designColor={app.designColor}
          font={app.font}
          manager={false}
          property={true}
        />
        <PropertyComponent
          key={2}
          isDesktop={isDesktop}
          app_data={app_data}
          head={head}
          app={app}
          builder={builder}
          navigation={navigation}
          content={content}
          locations={locations}
          footer={footer}
          captchaSiteKey={captchaSiteKey}
          all_images={all_images}
          features={features}
          page_title={content.page_title}
          phone={head.location[0].phone}
          removeHeader={false}
          footerPaddingClass={!isDesktop ? 'search-xs-p-b-70' : ""}
        />
        {/*<Suspense>*/}
        {/*  <PropertySections*/}
        {/*    key={2}*/}
        {/*    isDesktop={isDesktop}*/}
        {/*    app_data={app_data}*/}
        {/*    head={head}*/}
        {/*    app={app}*/}
        {/*    builder={builder}*/}
        {/*    navigation={navigation}*/}
        {/*    content={content}*/}
        {/*    locations={locations}*/}
        {/*    footer={footer}*/}
        {/*    captchaSiteKey={captchaSiteKey}*/}
        {/*    all_images={all_images}*/}
        {/*    features={features}*/}
        {/*    page_title={content.page_title}*/}
        {/*    phone={head.location[0].phone}*/}
        {/*  />*/}
        {/*</Suspense>*/}
        {/*<Scripts key={3}/>*/}
        {/*<PropertyScripts key={4}/>*/}
        {/*<Addons*/}
        {/*  key={5}*/}
        {/*  script_sections={null}*/}
        {/*/>*/}
      </MainLayout>
  );
}

// export async function getServerSideProps ({ req, res, query }) {
export const getServerSideProps = wrapper.getServerSideProps( ( store ) =>
  async ({
             req,
             res,
             query
  }) => {
    Checkers.fetchQueryParamateres(store, query)

    const [isMobile, isTablet, isDesktop] = Checkers.getUserAgentData(store, req)

    // res.setHeader(
    //   'Cache-Control',
    //   'public, s-maxage=43200, stale-while-revalidate=60'
    // )
    const redis = new Redis(process.env.REDIS);
    let subdomain = null;
    const slug_data = null;

    let head = null;
    let app = null;
    let page = null;
    let app_data = null;
    let navigation = null;
    let content = null;
    let html_sections = null;
    let all_images = null;
    let features = null;
    //const script_sections = null;
    let locations = null;
    let footer = null;
    let rgbSearchbarColor = null;
    let rgbDesignColor = null;
    //const amenities = null;
    const property_id = query.property;

    let manifest = null;

    const domain = req.headers.host;
    const hostname_parts = req.headers.host.split('.');
    const parts = hostname_parts.length;

    app_data = await DataFetchHelper.fetchAppData(req, redis, res);

    html_sections = await fetchHtmlSectionsData( redis, app_data.page_id )

    let checkIn = store.getState().propertiesParams.checkin
    let checkOut = store.getState().propertiesParams.checkout
    let availabilityData = await DataFetchHelper.fetchPropertyAvailability(redis, app_data.page_id, property_id, checkIn, checkOut, 0)

    let availabilityDataForCheckout = await DataFetchHelper.fetchPropertyAvailability(redis, app_data.page_id, property_id, checkIn, checkOut, 1)
    if (availabilityDataForCheckout.result != undefined) {
      store.dispatch(updatePropertyInitialAvailability(availabilityDataForCheckout.result[1].isAvailable))
    }
    store.dispatch(updatepropertyAvailability(availabilityData))
    store.dispatch(updatepropertyAvailabilityForCheckout(availabilityDataForCheckout))

    store.dispatch(setPageId(app_data.page_id))

    if (app_data != null) {
      page = await DataFetchHelper.fetchPageData(redis, app_data.page_id);
      head = await DataFetchHelper.fetchHeadData(redis, app_data.page_id);
      content = await DataFetchHelper.fetchPropertyContent(redis, app_data.page_id, property_id, store);


      if (content.hasOwnProperty('details') && content.details.hasOwnProperty('property_status')) {
        if (content.details.property_status!=3) {
          redis.disconnect(false)

          return {
            notFound: true,
          }
        }
      }

      if (content.is_active != true) {
        res.setHeader('Location', '/');
        res.statusCode = 302;
        res.end();
      }

      //5.5KB (may defers)
      all_images = await DataFetchHelper.fetchData(redis, "/api/lodge/frontend/get/property/images/", "property", property_id, null, 0, app_data.page_id)
      //12.76 KB (may defers)
      const property_features_params = {
        parent: 2,
        is_featured: 1,
        locale: 'en',
        active_only: 1,
        property_id: property_id
      };
      features = await DataFetchHelper.fetchData(redis, "/api/lodge/properties/features-by-group/all", "property", property_id, property_features_params, 0, app_data.page_id)
      // 6.76 KB
      app = await DataFetchHelper.fetchSettingsData(redis, app_data.page_id, store);
      // 1.29 KB
      navigation = await DataFetchHelper.fetchNavigationData(redis, app_data.page_id);

      locations = await DataFetchHelper.fetchLocationsData(redis, app_data.page_id);

      footer = await DataFetchHelper.fetchFooterData(redis, app_data.page_id)

      store.dispatch(updateHideUnavailableProperties(1))
    }

    if (Object.keys(head).length > 0) {
      manifest = MethodHelper.initManifest(head, app, '../../?source=pwa');
      manifest = MethodHelper.extendManifest(manifest, head);

      const json = JSON.stringify(manifest);
      const fs = require('fs');
      fs.writeFile('./public/manifest.json', json, (err) => {
        if (err) {
          redis.disconnect(false)

          // eslint-disable-next-line no-console
          console.error(err)
          return
        }
      });
    }

    if (app != null && app.searchbarBgColor != null)
      rgbSearchbarColor = MethodHelper.hexToRgb(app.searchbarBgColor);
    if (app != null && app.designColor)
      rgbDesignColor = MethodHelper.hexToRgb(app.designColor);

    // redis.disconnect()

    redis.disconnect(false)

    return {
      props: {
        app_data: app_data,
        head: head,
        page: page != null ? page.page : null,
        app: app,
        builder: app != null && app.builder != null ? app.builder : null,
        navigation: navigation,
        content: content,
        all_images: all_images,
        features: features,
        locations: locations,
        html_sections: html_sections,
        footer: footer,
        domain: domain,
        subdomain: subdomain,
        parts: parts,
        slug_data: slug_data,
        rgbDesignColor: rgbDesignColor,
        rgbSearchbarColor: rgbSearchbarColor,
        isDesktop: isDesktop,
        isMobile: isMobile,
        isTablet: isTablet,
      }
    }
  })

export default Property;